module.exports = __webpack_public_path__ + "img/background_honely.25c8500d.png";